import React from 'react';

const TwoColumnWithDetailContent =
  ({ DetailContentFn, TwoColumnContentFn, mapVariantToProps, mapVariantToClassName }: any) =>
  ({ title, columnRatio, leftColumn = [], rightColumn = [], theme, className }: any) => (
    <TwoColumnContentFn
      title={title}
      columnRatio={columnRatio}
      className={className}
      theme={theme}
      leftColumn={
        leftColumn && (
          <DetailContentFn
            content={leftColumn}
            mapVariantToProps={mapVariantToProps}
            mapVariantToClassName={mapVariantToClassName}
            theme={theme}
          />
        )
      }
      rightColumn={
        rightColumn && (
          <DetailContentFn
            content={rightColumn}
            mapVariantToProps={mapVariantToProps}
            mapVariantToClassName={mapVariantToClassName}
            theme={theme}
          />
        )
      }
    />
  );

export default TwoColumnWithDetailContent;
